export enum Distribuidora {
  S = '23',
  F = '22',
  E = '24',
  L = '39',
}
